import React from 'react';
import conhecta_logo_mobile from '../../../../assets/images/conhecta_logo_mobile.svg';
import conhecta_logo from '../../../../assets/images/conhecta_logo.svg';

const Logo = () => {
    return (
        <>
            <div className='header-div-logo-mobile'>
                <img className='header-logo-mobile' src={conhecta_logo_mobile} alt="" />
            </div>
            <div className='header-div-logo'>
                <img className='header-logo' src={conhecta_logo} alt="" />
            </div>            
        </>
    );
};

export default Logo;